// extracted by mini-css-extract-plugin
export default {"noInternet":"style_noInternet__a+2Jm"};